/*globals jQuery, MSR, setTimeout, customAWA */
( function ( $ ) {

	var retryLimit = {},
		retryCount = {};

	function request_tabs( url, container, args ) {
		args = args || {};

		// /news-tab/ urls return HTML instead of json
		if ( url.search( '/news-tab/' ) >= 0 || url.search('news-tab=true') >= 0 ) {
			dataType = 'html';
			container.load( url, function() {
				window.MSR.facetedSearch.init();
			} );
			return false;
		}

		$.get( url, function ( response ) {
			var wrapper;

			if ( typeof response.content === 'undefined' ) {
				retryCount[url]++;
				if ( retryLimit[url] > retryCount[url] ) {
					console.log( 'Retry: ' + url + ' -  missing content property' );
					console.log( response.responseText );
					request_tabs( url, container );
				}
			}

			if ( response.type === 'publications' ) {
				window.MSR_Accordion_Data = response.content;
				wrapper = document.getElementById( 'tmpl-publications-container' ).innerHTML;
				wrapper = wrapper.replace( '{%- accordionLayout %}', response.content.criteria.layout );
			} else {
				wrapper = document.createElement( 'div' );
				wrapper.id = 'related-posts-' + response.type;
				wrapper.className = args.wrapperClass || 'ms-row';

				$( response.content ).each( function ( index, item ) {
					$( wrapper ).append( item.html );
				} );

			}

			container.html( wrapper );

			if ( response.more_pages ) {
				container.append( response.more_pages );
			} else {
				$( '#show-more-wrapper', container ).remove();
			}

			if ( response.type === 'publications' ) {
				window.MSR.profilePublicationsSort.init();
				container.find( '#msr-sort-publications' ).val( response.content.criteria.group );
				container.find( 'form.publications-sort' ).submit();
			}

			if ( response.type === 'news-and-awards' ) {
				window.MSR.facetedSearch.init();
			}

			var loadTabEvent = new CustomEvent( 'msr:loadTabComplete' );
			document.dispatchEvent( loadTabEvent );

		}, 'json' ).fail( function ( response ) {
			retryCount[url]++;
			if ( retryLimit[url] > retryCount[url] ) {
				console.log( 'Retry: ' + url );
				console.log( response.responseText );
				request_tabs( url, container );
			}
		} );
	}

	$.fn.loadTab = function ( url, args ) {
		var $self = $( this );

		setTimeout( function () {
			$self.find( '.tab-loader' ).css( 'display', 'block' );
		}, 500 );

		retryLimit[url] = 3;
		retryCount[url] = 0;

		request_tabs( url, $self, args );
		return this;
	};

}( jQuery ) );
